import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface FilterOption {
  v: string;
  l: string;
}

export interface FilterField {
  label: string;
  value: string;
  options: FilterOption[];
  border: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export interface FilterPanelProps {
  showFilters: boolean;
  filterFields: FilterField[];
  isCustom: boolean;
  from: string;
  to: string;
  onFrom: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTo: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
  showFilters,
  filterFields,
  isCustom,
  from,
  to,
  onFrom,
  onTo
}) => {
  const { t } = useTranslation();

  if (!showFilters) return null;

  return (
    <div
      style={s(
        `background:#fff;border:1px solid #E6E8EC;border-radius:12px;padding:16px;display:grid;grid-template-columns:repeat(auto-fit,minmax(170px,1fr));gap:12px`
      )}
    >
      {filterFields?.map((ff, ff_idx) => (
        <React.Fragment key={ff_idx}>
          <label style={s(`display:flex;flex-direction:column;gap:6px;min-width:0`)}>
            <span style={s(`font-size:12px;font-weight:500;color:#6B7280`)}>{ff.label}</span>
            <div style={s(`position:relative`)}>
              <select
                value={ff.value}
                onChange={ff.onChange}
                style={s(
                  `width:100%;height:38px;border:1px solid ${ff.border};border-radius:8px;padding:0 32px 0 12px;font-size:14px;color:#1B2430;background:#fff;cursor:pointer;outline:0`
                )}
              >
                {ff.options?.map((o, o_idx) => (
                  <React.Fragment key={o_idx}>
                    <option value={o.v}>{o.l}</option>
                  </React.Fragment>
                ))}
              </select>
              <i className="icon-chevron-down" style={s(`position:absolute;right:10px;top:11px;color:#6B7280;pointer-events:none`)}></i>
            </div>
          </label>
        </React.Fragment>
      ))}
      {Boolean(isCustom) && (
        <>
          <label style={s(`display:flex;flex-direction:column;gap:6px`)}>
            <span style={s(`font-size:12px;font-weight:500;color:#6B7280`)}>{t('managerNetwork.filter.from', 'From')}</span>
            <input
              type="date"
              value={from}
              onChange={onFrom}
              style={s(`height:38px;border:1px solid #E3E6EA;border-radius:8px;padding:0 10px;font-size:14px;color:#1B2430`)}
            />
          </label>
          <label style={s(`display:flex;flex-direction:column;gap:6px`)}>
            <span style={s(`font-size:12px;font-weight:500;color:#6B7280`)}>{t('managerNetwork.filter.to', 'To')}</span>
            <input
              type="date"
              value={to}
              onChange={onTo}
              style={s(`height:38px;border:1px solid #E3E6EA;border-radius:8px;padding:0 10px;font-size:14px;color:#1B2430`)}
            />
          </label>
        </>
      )}
    </div>
  );
};
